export default __webpack_public_path__ + "static/media/rambouillet01min.1ea6c1bd.jpg";